import { createContext, useContext } from 'react';
import { useReducedToastQueue } from './hooks/useReducedToastQueue';
import ToastStack from './Toast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
    const { addToast, removeToast, clearToasts, toasts } = useReducedToastQueue();

    return (
        <ToastContext.Provider value={{ addToast, removeToast, clearToasts }}>
            {children}
            <ToastStack toasts={toasts} removeToast={removeToast} />
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
